import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'

export default {
	async [actionTypes.PEDIDO.DOCUMENTOS.DOCUMENTO.EDITOR_TEXTO.ADICIONAR](context, documento) {
		const { data } = await api.documentosPedidoEditorTexto.adicionarDocumento(documento)
		return data
	},

	async [actionTypes.PEDIDO.DOCUMENTOS.DOCUMENTO.EDITOR_TEXTO.REDIGIR](context, idDocumento) {
		const { data } = await api.documentosPedidoEditorTexto.redigir(idDocumento)
		return data
	},

	async [actionTypes.PEDIDO.DOCUMENTOS.DOCUMENTO.EDITOR_TEXTO.VISUALIZAR](context, idDocumento) {
		const { data } = await api.documentosPedidoEditorTexto.visualizar(idDocumento)
		return data
	},

	async [actionTypes.PEDIDO.DOCUMENTOS.DOCUMENTO.EDITOR_TEXTO.SINCRONIZAR](context, idDocumento) {
		const { data } = await api.documentosPedidoEditorTexto.sincronizar(idDocumento)
		return data
	},

	async [actionTypes.PEDIDO.DOCUMENTOS.DOCUMENTO.EDITOR_TEXTO.BUSCAR_POR_ID](context, idDocumento) {
		const { data } = await api.documentosPedidoEditorTexto.buscarPorId(idDocumento)
		return data
	},
}
